export default function CrossIcon() {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="22" height="22" rx="11" fill="#FF4950" />
      <rect
        x="1"
        y="1"
        width="22"
        height="22"
        rx="11"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M15.7455 8.25411L15.7459 8.2545C15.8264 8.33497 15.8904 8.43052 15.934 8.5357L16.3907 8.34636L15.934 8.53571C15.9776 8.64088 16 8.75363 16 8.86749C16 8.98135 15.9776 9.0941 15.934 9.19928C15.8904 9.30446 15.8264 9.40001 15.7459 9.48048L15.7457 9.48068L13.5799 11.6464L13.2264 12L13.5799 12.3536L15.7457 14.5193C15.9083 14.682 15.9997 14.9025 15.9997 15.1325C15.9997 15.3625 15.9083 15.5831 15.7457 15.7457C15.5831 15.9083 15.3625 15.9997 15.1325 15.9997C14.9025 15.9997 14.682 15.9083 14.5193 15.7457L12.3536 13.5799L12 13.2264L11.6464 13.5799L9.48068 15.7457L9.48048 15.7459C9.40001 15.8264 9.30446 15.8904 9.19928 15.934C9.0941 15.9776 8.98135 16 8.86749 16C8.75363 16 8.64088 15.9776 8.53571 15.934L8.34636 16.3907L8.5357 15.934C8.43052 15.8904 8.33497 15.8264 8.2545 15.7459L8.25411 15.7455C8.17355 15.665 8.10964 15.5695 8.06604 15.4643C8.02244 15.3591 8 15.2464 8 15.1325C8 15.0186 8.02244 14.9059 8.06604 14.8007C8.10964 14.6955 8.17355 14.6 8.25411 14.5195L8.2543 14.5193L10.4201 12.3536L10.7736 12L10.4201 11.6464L8.2543 9.48068L8.25411 9.48048C8.17355 9.40001 8.10964 9.30446 8.06604 9.19928L7.6834 9.3579L8.06604 9.19928C8.02244 9.0941 8 8.98135 8 8.86749C8 8.75363 8.02244 8.64088 8.06604 8.5357C8.10964 8.43052 8.17355 8.33497 8.25411 8.2545L8.2545 8.25411C8.33497 8.17355 8.43052 8.10964 8.5357 8.06604C8.64088 8.02244 8.75363 8 8.86749 8C8.98135 8 9.0941 8.02244 9.19928 8.06604L9.39075 7.60416L9.19928 8.06604C9.30446 8.10964 9.40001 8.17355 9.48048 8.25411L9.48068 8.2543L11.6464 10.4201L12 10.7736L12.3536 10.4201L14.5193 8.2543L14.5195 8.25411C14.6 8.17355 14.6955 8.10964 14.8007 8.06604C14.9059 8.02244 15.0186 8 15.1325 8C15.2464 8 15.3591 8.02244 15.4643 8.06604C15.5695 8.10964 15.665 8.17355 15.7455 8.25411Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
}
